import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const PesquisarNormas = () => {
  return (
    <div>
      <h1>PesquisarNormas</h1>
    </div>
  );
};

export default PesquisarNormas;
